module.exports = __webpack_public_path__ + "abc96c01c8f4f2a13f4613e85a0735bd.svg";